export default __webpack_public_path__ + "static/media/training.dc0b9a4b.svg";